<template>
	<vSelect
		multiple
		:clearable="false"
		:searchable="false"
		:components="{ Deselect, OpenIndicator }"
		@option:selected="($event) => $emit('change', $event)"
	>
		<template #no-options="{ search, searching, loading }">
		Ingen resultater
		</template>
	</vSelect>
</template>
<script setup>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "@oldSrc/assets/vue-select.css";
import Deselect from "./Deselect.vue";
import OpenIndicator from "./OpenIndicator.vue";
</script>
